import {Component, OnInit, OnDestroy} from '@angular/core';

@Component({
  selector: 'app-partfolio',
  templateUrl: './portfolio.component.html',
  styleUrls: ['./portfolio.component.css']
})
export class PortfolioComponent implements OnInit, OnDestroy {

  constructor() { }

  ngOnInit() {
    $('.subHeader').addClass('subCoverPortfolio');
    $('.portfolioLink').addClass('activeLink');
    $('.portfolioLink a').css('color', 'white');
    $('.headline h1').text('PORTFOLIO');
  }

  ngOnDestroy() {
    $('.subHeader').removeClass('subCoverPortfolio');
    $('.portfolioLink').removeClass('activeLink');
  }

}



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/portfolio/portfolio.component.ts